import moment, { Moment } from 'moment';

type DateLike = Date | Moment | number | string;

export function maxAllowedEndDate(start: DateLike, now: DateLike = new Date()): Date {
  return moment.min(
    moment(start).add(1, 'month'),
    moment(now).endOf('day')
  ).toDate();
}

export function isGraphDateRangeValid(start: DateLike, end: DateLike, now: DateLike = new Date()): boolean {
  return !moment(end).isAfter(maxAllowedEndDate(start, now), 'day');
}

export function clampEndDateForStart(start: DateLike, end: DateLike, now: DateLike = new Date()): Date {
  const maxEnd = maxAllowedEndDate(start, now);
  return moment(end).isAfter(maxEnd, 'day') ? maxEnd : moment(end).toDate();
}

export function minAllowedStartDate(end: DateLike): Date {
  const endMoment = moment(end);
  const start = endMoment.clone().subtract(1, 'month');
  if (start.clone().add(1, 'month').isBefore(endMoment, 'day')) {
    return endMoment.clone().startOf('month').toDate();
  }
  return start.toDate();
}

export function clampStartDateForEnd(start: DateLike, end: DateLike): Date {
  const minStart = minAllowedStartDate(end);
  return moment(start).isBefore(minStart, 'day') ? minStart : moment(start).toDate();
}
